<section class="hero-wrap hero-ui">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-center justify-content-center">
        <div class="col-md-9 pt-5 text-center">
          <p class="breadcrumbs"><span class="mr-2"><a href="">Home <i class="fa fa-chevron-right"></i></a></span> <span>Properties <i class="fa fa-chevron-right"></i></span></p>
          <h1 class="mb-0 bread">
            Properties
          </h1>
        </div>
      </div>
    </div>
  </section>
<!-- Range -->
<section class="ftco-section ftco-no-pb ftco-no-pt bg-light hero-ui-search">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="ftco-search d-flex justify-content-center">
            <div class="row">
              <div class="col-md-12 nav-link-wrap d-flex justify-content-center">
                <div class="nav nav-pills text-center" id="v-pills-tab" role="tablist">
                  <a class="nav-link active" id="v-pills-1-tab" data-toggle="pill" href="#v-pills-1" role="tab">Buy Properties</a>

                  <a class="nav-link" id="v-pills-2-tab" data-toggle="pill" href="#v-pills-2" role="tab">Rent Properties</a>

                </div>
              </div>
              <div class="col-md-12 tab-wrap">
                
                <div class="tab-content" id="v-pills-tabContent">

                  <div class="tab-pane fade show active" id="v-pills-1" role="tabpanel">
                    <form action="#" class="search-property-1">
                      <div class="row g-0">
                        <div class="col-md d-flex">
                          <div class="form-group p-4 border-0">
                            <label for="#">Enter Keyword</label>
                            <div class="form-field">
                              <div class="icon"><span class="fa fa-search"></span></div>
                              <input type="text" class="form-control" placeholder="Enter Keyword">
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md d-flex">
                          <div class="form-group p-4">
                            <label for="#">Property Type</label>
                            <div class="form-field">
                              <div class="select-wrap">
                                <div class="icon"><span class="fa fa-chevron-down"></span></div>
                                <select name="" id="" class="form-control">
                                  <option value="">Residential</option>
                                  <option value="">Commercial</option>
                                  <option value="">Land</option>
                                  <option value="">Industrial</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div class="col-md d-flex" [class.open]="isDropdownOpen">
                          <div class="form-group p-4">
                            <label for="#">Property Type</label>
                            <div class="form-field">
                              <div class="select-wrap">
                                <div class="icon"><span class="fa fa-chevron-down mr-1"></span></div>
                                <div class="custom-dropdown">
                                  <div class="selected-option" (click)="toggleDropdown()">
                                    {{ selectedOption || 'Select an option' }}
                                  </div>
                                  <div class="options" *ngIf="isDropdownOpen">
                                    <div *ngFor="let option of propertyTypes" (click)="selectOption(option)" [ngClass]="selectedOption == option ? 'selected-option-dropdown' : ''">
                                      {{ option }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="col-md d-flex">
                          <div class="form-group p-4">
                            <label for="#">Location</label>
                            <div class="form-field">
                              <div class="icon"><span class="ion-ios-pin"></span></div>
                              <input type="text" class="form-control" placeholder="Search Location">
                            </div>
                          </div>
                        </div>
                        <div class="col-md d-flex" [class.open]="isPriceLimitDropdownOpen">
                          <div class="form-group p-4">
                            <label for="#">Price Limit</label>
                            <div class="form-field">
                              <div class="select-wrap">
                                <div class="icon"><span class="fa fa-chevron-down mr-1"></span></div>
                                <div class="custom-dropdown">
                                  <div class="selected-option" (click)="priceLimitToggleDropdown()">
                                    {{ priceLimitselectedOption || 'Select an option' }}
                                  </div>
                                  <div class="options" *ngIf="isPriceLimitDropdownOpen">
                                    <div *ngFor="let option of priceLimit" (click)="priceLimitSelectOption(option)" [ngClass]="priceLimitselectedOption == option ? 'selected-option-dropdown' : ''">
                                      {{ option }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="col-md d-flex">
                          <div class="form-group p-4">
                            <label for="#">Price Limit</label>
                            <div class="form-field">
                              <div class="select-wrap">
                                <div class="icon"><span class="fa fa-chevron-down"></span></div>
                                <select name="" id="" class="form-control">
                                  <option value="">100 AED</option>
                                  <option value="">10,000 AED</option>
                                  <option value="">50,000 AED</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div class="col-md d-flex">
                          <div class="form-group d-flex w-100 border-0">
                            <div class="form-field w-100 align-items-center d-flex">
                              <input type="submit" value="Search" class="align-self-stretch form-control btn btn-primary">
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="tab-pane fade" id="v-pills-2" role="tabpanel">
                    <form action="#" class="search-property-1">
                      <div class="row g-0">
                        <div class="col-md d-flex">
                          <div class="form-group p-4 border-0">
                            <label for="#">Enter Keyword</label>
                            <div class="form-field">
                              <div class="icon"><span class="fa fa-search"></span></div>
                              <input type="text" class="form-control" placeholder="Enter Keyword">
                            </div>
                          </div>
                        </div>
                        <div class="col-md d-flex" [class.open]="isDropdownOpen">
                          <div class="form-group p-4">
                            <label for="#">Property Type</label>
                            <div class="form-field">
                              <div class="select-wrap">
                                <div class="icon"><span class="fa fa-chevron-down mr-1"></span></div>
                                <div class="custom-dropdown">
                                  <div class="selected-option" (click)="toggleDropdown()">
                                    {{ selectedOption || 'Select an option' }}
                                  </div>
                                  <div class="options" *ngIf="isDropdownOpen">
                                    <div *ngFor="let option of propertyTypes" (click)="selectOption(option)" [ngClass]="selectedOption == option ? 'selected-option-dropdown' : ''">
                                      {{ option }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md d-flex">
                          <div class="form-group p-4">
                            <label for="#">Location</label>
                            <div class="form-field">
                              <div class="icon"><span class="ion-ios-pin"></span></div>
                              <input type="text" class="form-control" placeholder="Search Location">
                            </div>
                          </div>
                        </div>
                        <div class="col-md d-flex" [class.open]="isPriceLimitDropdownOpen">
                          <div class="form-group p-4">
                            <label for="#">Price Limit</label>
                            <div class="form-field">
                              <div class="select-wrap">
                                <div class="icon"><span class="fa fa-chevron-down mr-1"></span></div>
                                <div class="custom-dropdown">
                                  <div class="selected-option" (click)="priceLimitToggleDropdown()">
                                    {{ priceLimitselectedOption || 'Select an option' }}
                                  </div>
                                  <div class="options" *ngIf="isPriceLimitDropdownOpen">
                                    <div *ngFor="let option of priceLimit" (click)="priceLimitSelectOption(option)" [ngClass]="priceLimitselectedOption == option ? 'selected-option-dropdown' : ''">
                                      {{ option }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md d-flex">
                          <div class="form-group d-flex w-100 border-0">
                            <div class="form-field w-100 align-items-center d-flex">
                              <input type="submit" value="Search" class="align-self-stretch form-control btn btn-primary">
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="ftco-section bg-light">
     <div class="properties-grid">
        <ng-container *ngFor="let propertyData of propertyList">
          <app-common-property [propertyData]='propertyData'></app-common-property>
        </ng-container>
      
    </div>
  </section>

  <!-- <section class="ftco-section bg-light">
    <div class="container-xl">
      <div class="row">
        <div class="col-md-3" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-1.jpg);">
              <p class="price"><span class="orig-price">300,000 AED</span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="sale">Sale</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-2.jpg);">
              <p class="price"><span class="old-price">800,000</span><span class="orig-price">3,050 AED<small> / mo</small></span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="rent">Rent</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-3.jpg);">
              <p class="price"><span class="orig-price">300 AED</span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="sale">Sale</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3" data-aos="fade-up" data-aos-delay="400" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-4.jpg);">
              <p class="price"><span class="orig-price">300 AED<small> / mo</small></span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="rent">Rent</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-3" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-5.jpg);">
              <p class="price"><span class="orig-price">300,000 AED</span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="sale">Sale</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-6.jpg);">
              <p class="price"><span class="old-price">800,000</span><span class="orig-price">3,050 AED<small> / mo</small></span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="rent">Rent</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-7.jpg);">
              <p class="price"><span class="orig-price">300 AED</span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="sale">Sale</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3" data-aos="fade-up" data-aos-delay="400" data-aos-duration="1000">
          <div class="property-wrap">
            <a href="/properties-single" class="img img-property" style="background-image: url(../../assets/images/work-8.jpg);">
              <p class="price"><span class="orig-price">300 AED<small> / mo</small></span></p>
            </a>
            <div class="text">
              <div class="list-team d-flex align-items-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="img" style="background-image: url(../../assets/images/person_1.jpg);"></div>
                  <h3 class="ml-2">
                    John Dorf
                  </h3>
                </div>
                <span class="text-right">2 weeks ago</span>
              </div>
              <h3>
                <a href="/properties-single">Sunny Loft Property</a>
              </h3>
              <span class="location"><i class="ion-ios-pin"></i> New York <span class="rent">Rent</span></span>
              <ul class="property_list mt-3 mb-0">
                <li><span class="flaticon-bed"></span>3</li>
                <li><span class="flaticon-bathtub"></span>2</li>
                <li><span class="flaticon-blueprint"></span>1,878 sqft</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col text-center">
          <div class="block-27">
            <ul>
              <li><a href="/properties">&lt;</a></li>
              <li class="active"><span>1</span></li>
              <li><a href="/properties">2</a></li>
              <li><a href="/properties">3</a></li>
              <li><a href="/properties">4</a></li>
              <li><a href="/properties">5</a></li>
              <li><a href="/properties">&gt;</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section> -->

